import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Reveal } from "@/components/site/Motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-stone-50 min-h-screen">
      <Navbar />
      <main className="px-6 md:px-12 lg:px-24 pt-40 md:pt-52 pb-24">
        <Reveal>
          <h4 className="font-sans text-sm tracking-[0.2em] uppercase text-faint mb-4">Ideas & Perspectivas</h4>
          <h1 className="font-serif text-5xl md:text-7xl tracking-tighter text-ink">Blog</h1>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-x-10 gap-y-16">
          {posts.length === 0 && <p className="font-sans text-subtle">Aún no hay artículos publicados.</p>}
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
                <div className="overflow-hidden aspect-[16/10] bg-stone-100 rounded-sm mb-6">
                  {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight group-hover:text-subtle transition-colors duration-300">{p.title}</h2>
                <p className="font-sans text-sm md:text-base text-subtle mt-3 leading-relaxed">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 font-sans text-sm text-ink mt-4">Leer artículo <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer content={content} />
    </div>
  );
}
